module.exports = __webpack_public_path__ + "img/newly_added.861c71d7.png";